import { institutionService } from "../services/institution.service";
import { show as showAlert } from "../../Notifications/actions/alert.actions";
import { message } from "../../../constants/app.constants";
import { institutionConstants, institutionFEPConstants, nameSpace, nameFepSpace } from "../constants/institution.constants";
import { reset } from "redux-form";


export const getInstitutions = (requestParams) => {
    return async (dispatch) => {
        dispatch(request(requestParams));
        try {
            const response = await institutionService.getInstitutions(requestParams);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: institutionConstants[`GET_${nameSpace}_REQUEST`], request };
    }
    function success(response) {
        return { type: institutionConstants[`GET_${nameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: institutionConstants[`GET_${nameSpace}_FAILURE`], error };
    }
};

export const getInstitution = (id) => {
    return async (dispatch) => {
        dispatch(request(id));
        try {
            const response = await institutionService.getInstitutionById(id);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Error!", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: institutionConstants[`VIEW_${nameSpace}_REQUEST`], request };
    }
    function success(response) {
        return { type: institutionConstants[`VIEW_${nameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: institutionConstants[`VIEW_${nameSpace}_FAILURE`], error };
    }
};

export const getFEPs = () => {
    return async (dispatch) => {
        dispatch(request());
        try {
            const response = await institutionService.getFEPs();
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: institutionFEPConstants[`GET_${nameFepSpace}_REQUEST`], request };
    }
    function success(response) {
        return { type: institutionFEPConstants[`GET_${nameFepSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: institutionFEPConstants[`GET_${nameFepSpace}_FAILURE`], error };
    }
};

export const postInstitution = (values, cb) => {
    return async (dispatch) => {
        dispatch(request(values));
        await institutionService.createInstitution(values)
        .then(response => {
            dispatch(success(response))
            dispatch(reset("institution_form"));
            dispatch(showAlert("success", `Institution - ${values.name} was ${values && values.stat  && values.stat === "edit" ? "updated" : "created"} successfully`));
            cb();
            dispatch(resetView());
        })
        .catch(error => {
            dispatch(failure(error));
            
            if(error && error.response){
                return dispatch(showAlert("danger", error));
            }
            dispatch(showAlert("danger", `Failed to ${values && values.stat  && values.stat === "edit" ? "update" : "create"} institution`, error ? error.message || error.description : message.GENERIC_ERROR));
        })
    };

    function request() {
        return { type: institutionConstants[`POST_${nameSpace}_REQUEST`] };
    }
    function success(response) {
        return { type: institutionConstants[`POST_${nameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: institutionConstants[`POST_${nameSpace}_FAILURE`], error };
    }
    function resetPost() {
        return { type: institutionConstants[`POST_${nameSpace}_RESET`] };
    }
    function resetView() {
        return { type: institutionConstants[`VIEW_${nameSpace}_RESET`] };
    }
};

export const resetPostInstitution = () => {
    return { type: institutionConstants[`POST_${nameSpace}_RESET`] };
};

export const resetViewInstitution = () => {
    return { type: institutionConstants[`VIEW_${nameSpace}_RESET`] };
};